import { render } from "./list-share.vue?vue&type=template&id=322c38eb&scoped=true&ts=true"
import script from "./list-share.vue?vue&type=script&lang=ts"
export * from "./list-share.vue?vue&type=script&lang=ts"

import "./list-share.vue?vue&type=style&index=0&id=322c38eb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322c38eb"]])

export default __exports__